import useWalletInfoQuery from './useWalletInfoQuery';

const useCurrentAccount = () => {
  const { currentAccount } = useWalletInfoQuery();

  return currentAccount;
};

export default useCurrentAccount;
